import { logAppError } from 'Helpers/logger'
import { composerState } from '../states/page'
import getIntl from 'Helpers/intl'
import {
  GetAgileToken,
  copyTemplate,
  deleteTemplate,
  getAllListSenders,
  getDynamicFieldsDefinition,
  getListAllSmsAlias,
} from '../actions/actions'
import type { CallbackInterface } from 'recoil'
import { pageState } from 'State/page'

export const resetCallback =
  ({ set, reset }: CallbackInterface) =>
  async () => {
    reset(pageState)
    reset(composerState)
  }

export const initCallback =
  ({ set, reset }: CallbackInterface) =>
  async () => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true,
      error: false,
    }))

    try {
      const [token, dynamicFields, allListSender, allSmsAlias] =
        await Promise.all([
          GetAgileToken(),
          getDynamicFieldsDefinition(),
          getAllListSenders(),
          getListAllSmsAlias(),
        ])
      const dynamicFieldsList = dynamicFields.map((m) => m.Description)
      dynamicFieldsList.unshift('Email', 'Prefix', 'Number', 'SubSMS')
      const senderPhoneNumbers = allListSender.Result.map(
        (m) => m.NumericSender,
      )
      const senderAlias = allSmsAlias.Items.map((m) => m.Alias)

      set(composerState, (prev) => ({
        ...prev,
        token: token.Token,
        dynamicFields: dynamicFieldsList,
        senderPhoneNumbers: senderPhoneNumbers,
        senderAlias: senderAlias,
      }))
    } catch (error) {
      logAppError({ appError: error })
      set(pageState, (prev) => ({
        ...prev,
        errorMessage: getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric',
        }),
      }))
    }

    set(pageState, (prev) => ({
      ...prev,
      status: 'ready',
      loading: false,
    }))
  }

export const upsertMessageCallback =
  ({ set, reset }: CallbackInterface) =>
  async (templateId: number) => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true,
      error: false,
    }))
    let ret = null

    try {
      ret = await copyTemplate(templateId)
    } catch (error) {
      logAppError({ appError: error })
      set(pageState, (prev) => ({
        ...prev,
        errorMessage: getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric',
        }),
        severity: 'danger',
      }))
    }

    set(pageState, (prev) => ({
      ...prev,
      loading: false,
      loaded: true,
    }))

    return ret
  }

export const deleteTemplateCallback =
  ({ set, reset }: CallbackInterface) =>
  async (templateId: number) => {
    set(pageState, (prev) => ({
      ...prev,
      loading: true,
      error: false,
    }))

    try {
      await deleteTemplate(templateId)
    } catch (error) {
      logAppError({ appError: error })
      set(pageState, (prev) => ({
        ...prev,
        errorMessage: getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric',
        }),
      }))
    }

    set(pageState, (prev) => ({
      ...prev,
      loading: false,
      loaded: true,
    }))
  }
